<script setup lang="ts">
import { computed } from 'vue'
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'
import PropertySection from './PropertySection.vue'
import type { PropertyDetail } from '../../types/propertyTypes'

// The listing copy our team wrote for this property — the same words an investor
// reads on the marketplace. Sellers ask to see it, and until now the only way was
// to find their own property in the investor app.
//
// The whole section is absent until a description exists, rather than showing an
// empty heading: the copy is written during enrichment, well after promotion.
const props = defineProps<{ property: PropertyDetail }>()

const hasDescription = computed(() =>
  Boolean(props.property.propertyShortDescription || props.property.propertyDescription),
)
</script>

<template>
  <PropertySection v-if="hasDescription" title="About this property">
    <Box direction="col" gap="3">
      <Text
        v-if="property.propertyShortDescription"
        type="body"
        weight="medium"
        class="about__lead"
      >
        {{ property.propertyShortDescription }}
      </Text>
      <Text v-if="property.propertyDescription" type="body" color="muted" class="about__body">
        {{ property.propertyDescription }}
      </Text>
    </Box>
  </PropertySection>
</template>

<style scoped>
.about__lead {
  line-height: 1.6;
}

/* Preserves the paragraph breaks ops typed; the column is capped so a long
   description stays readable rather than running the full width of a desktop. */
.about__body {
  line-height: 1.7;
  white-space: pre-line;
  max-width: 60ch;
}
</style>
